export enum CurrencyCode {
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  NOK = 'NOK',
  SEK = 'SEK',
  USD = 'USD',
  CHF = 'CHF',
}
